import { useOutletContext, Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import { Table, FormGroup, Input, Label } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { faUser as faRUser } from '@fortawesome/free-regular-svg-icons';

import { translations } from './../../../i18/translations.js';
import Search from './../../../util/Search.js';
import Pager from './../../../util/Pager.js';
import AdministrationLinkRow from './assets/AdministrationLinkRow.js';
import { Space } from './../../../util/Html.js';
import './JuniorManagement.css';

const JuniorManagement = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {user, lang, checkAccess} = useOutletContext();

    const [query, setQuery] = useState('');
    const [pageIndex, setPageIndex] = useState(0);
    const [onlyVerified, setOnlyVerified] = useState(true);
    const [pager, setPager] = useState([]);
    const [template, setTemplate] = useState('');

    const [juniors, setJuniors] = useState([]);

    const pageSize = 20;

    useEffect(() => {
        fetchMembers(pageIndex, query, onlyVerified);
    }, [pageIndex, query, onlyVerified, user]);

    const fetchMembers = async (pageIndex, queryString, onlyVerified) => {
        try {
            const payload = {
                filter: {
                    pageSize: 20,
                    pageIndex: pageIndex,
                    queryString: queryString,
                    onlyVerified: onlyVerified
                }
            };

            const response = await fetch(`${API_URL}/admin/get_junior_list.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setJuniors(data.data);
                setPager(data.pagerButtonIndexes);
                setTemplate(data.template);
            }
        } catch (error) {
            console.error("Error fetching junior members:", error);
        }
    };

    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].junior_management}</h1>
            
                <AdministrationLinkRow lang={lang} />
            
                <div className="junior-management-filter-container mb-3">            
                    <Search placeholder={translations[lang].search_member} handleSearch={setQuery} />
                    <FormGroup switch className="ms-auto">
                        <Input id="onlyMembersInUserList" type="switch" checked={onlyVerified} onClick={() => setOnlyVerified(!onlyVerified)} />
                        <Label for="onlyMembersInUserList" className="no-wrap" check>{translations[lang].only_verified}</Label>
                    </FormGroup>
                </div>
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>
                            <th style={{width: '25%'}}>{translations[lang].name}</th>
                            <th style={{width: '35%'}}>{translations[lang].institute}</th>
                            <th style={{width: '25%'}}>{translations[lang].email}</th>
                            <th style={{width: '15%'}}>{translations[lang].verified}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {juniors && juniors.map((junior) => (
                                <tr key={junior.id}>
                                    <td>{junior.fullname || <Space />}</td>
                            <td>{junior.institute || <Space />}</td>
                            <td>{junior.email || <Space />}</td>
                            <td>
                                {junior.fullname ? (
                                                                <>
                                                            <FontAwesomeIcon
                                                                icon={junior.verified === '1' ? faCheck : faExclamation}
                                                                />
                                                            </>
                                                            ) : (
                                                        <Space />
                                                    )}
                            </td>
                            </tr>
                                    ))}
                    </tbody>
                </Table>
            
                <Pager template={`${translations[lang].rows}: ${template}`} pager={pager} handlePageChange={setPageIndex} />
            
            </div>
            );
};

export default JuniorManagement;